package pl.decks.personal.components.graphics

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.dom.svg.Path
import com.varabyte.kobweb.compose.dom.svg.Svg
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.aspectRatio
import com.varabyte.kobweb.compose.ui.modifiers.height
import org.jetbrains.compose.web.css.px

@Composable
fun ExuraLogo(modifier: Modifier = Modifier) {
    val height = 138
    val width = 138

    Box(
        modifier = Modifier.height(height.px).aspectRatio(width, height).then(modifier),
        contentAlignment = Alignment.Center,
    ) {
        Svg(
            attrs = {
                viewBox(0, 0, width, height)
                attr("fill", "currentColor")
                style {
                    property("height", "100%")
                    property("width", "100%")
                }
            },
        ) {
            Path {
                d(
                    "M135.03,19.57c-3.08-7.73-9.25-13.9-16.98-16.98-22.14-8.82-43.77,6.07-45.69,27.15l-2.66," +
                            "29.05c-.21,2.25-3.34,2.61-4.05.47l-10.63-31.83c-2.97-8.91-11.3-14.91-20.69-14.91h-2.29c-10.78," +
                            "0-19.53,8.74-19.53,19.53v2.29c0,9.39,6.01,17.72,14.91,20.69l31.83,10.63c2.14.71,1.78,3.85-.47," +
                            "4.05l-29.05,2.67c-21.07,1.92-35.97,23.55-27.15,45.69,3.08,7.73,9.25,13.9,16.98,16.98,22.14," +
                            "8.82,43.77-6.07,45.69-27.15l2.66-29.05c.21-2.25,3.34-2.61,4.05-.47l10.63,31.83c2.97,8.91,11.3," +
                            "14.91,20.69,14.91h0c12.05,0,21.81-9.77,21.81-21.81,0-9.39-6.01-17.72-14.91-20.69l-31.82-10.63c-2." +
                            "14-.71-1.78-3.85.47-4.05l29.04-2.67c21.07-1.92,35.97-23.55,27.15-45.69Z"
                )
            }
        }
    }
}
